import React from 'react'

import { Layout, Showcase, Header, SectionTitle } from '../../../../components'

import data from './data.json'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>

        <Showcase
          site={data.site}
          title="Input Chip"
          text="Input chips represent user-entered or selected information. They appear inline within a text field. Input chips use the primary green treatment and do not change appearance. They are always dismissible."
        >
          <div class="c-chip__container">
            <div class="c-chip c-chip--active">
              Lorem Ipsum
              <div class="c-chip__icon">
                <i class="icon icon--close"></i>
              </div>
            </div>
          </div>
        </Showcase>
      </Layout>
    </>
  )
}
